import { render, staticRenderFns } from "./PeriodLockView.vue?vue&type=template&id=63432d4c&scoped=true&"
import script from "./PeriodLockView.vue?vue&type=script&lang=js&"
export * from "./PeriodLockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63432d4c",
  null
  
)

export default component.exports